import type { WidgetFactory } from '@examdojo/core/widget';
import { QuadraticFunctionWidget } from './functions/quadratic/quadratic-function.widget';
import { ArithmeticSeriesWidget } from './sequences/arithmetic-series/arithmetic-series.widget';
import { ArithmeticSequenceWidget } from './sequences/arithmetic/arithmetic-sequence.widget';

/**
 * Register all available widgets with the factory.
 * Call this during app initialization.
 */
export function registerAllWidgets(factory: WidgetFactory): void {
  factory.register('quadratic-function', QuadraticFunctionWidget as never);
  factory.register('arithmetic-sequence', ArithmeticSequenceWidget as never);
  factory.register('arithmetic-series', ArithmeticSeriesWidget as never);
}
